import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectSiteData, resetSnackBar } from "./site_data/siteDataSlice";

// Detect severity from message
const getSeverity = (msg = "") => {
  if (msg.includes("✅")) return "success";
  if (msg.includes("❌")) return "error";
  if (msg.includes("⚠️")) return "warning";
  return "info";
};

export default function MessageSnackbar() {
  const dispatch = useDispatch();
  const { show, message } = useSelector(selectSiteData);

  const handleClose = () => {
    dispatch(resetSnackBar());
  };

  const handleRequestClose = (event, reason) => {
    if (reason === "clickaway") return;
    dispatch(resetSnackBar());
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={show}
      autoHideDuration={4000}
      onClose={handleRequestClose}
    >
      <Alert
        onClose={handleClose}
        severity={getSeverity(message)}
        variant="filled"
        elevation={6}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
